export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const ACADEMY_GIFT_CARD = 'Academy Gift Cards';
export const ACADEMY_BULK_GIFT_CARD = 'Academy Bulk Gift Cards';

// formerly compiled into aso-env package...
export const sessionAPI = '/api/session ';
export const akamaiCoordURL = '/api/store/userCoordinates';
export const onlineStoreId = '10151';
export const basenameCart = '/shop/cart';
export const checkoutUrl = '/checkout';
export const signOutURL = '/shop/LogonForm?rememberMe=true';

// productDetailsUtils
export const PARAM_DEFAULT_SKU = 'repChildCatid';
export const PARAM_DEFAULT_PARTNUMBER = 'repChildCatSku';
export const INVENTORY_LOOK_UP_NOT_AVAILABLE_STORE = 'Store Inventory Lookup Not Available';
export const KEY_INVENTORY_LOOK_UP_NOT_AVAILABLE_STORE = 'INVENTORY_LOOK_UP_NOT_AVAILABLE_STORE';
export const INVENTORY_LOOK_UP_NOT_AVAILABLE_AT_SELECTED_ZIPCODE = 'Zipcode Inventory Lookup Not Available';
export const KEY_INVENTORY_LOOK_UP_NOT_AVAILABLE_SELECTED_ZIPCODE = 'KEY_INVENTORY_LOOK_UP_NOT_AVAILABLE_SELECTED_ZIPCODE';
export const KEY_NOT_SOLD_IN_STORE = 'NOT_SOLD_IN_STORE';
export const NOT_SOLD_IN_STORE = 'Not Available for Pickup';
export const KEY_BOPIS_INELIGIBLE = 'BOPIS_INELIGIBLE';
export const INVENTORY_BOPIS_NA = 'Pickup Not Available';
export const STR_ALL = 'ALL';
export const DEFINING = 'Defining';
export const LENGTH_OF_PANT = 'Length of Pant';
export const SHOE_WIDTH = 'Shoe Width';
export const SIZE_CHART_URL = 'sizeChartURL';
export const NOT_APPLICABLE = 'N/A';
export const CLEARANCE = 'Clearance';
export const HOT_DEAL = 'Hot Deal';
export const PRICE_DROP_DEAL = 'Price Drop';

/* list of US States for state dropdowns.
 * for "shipping" purposes, filter based on shipping=true, or see
 * the convenience constant below 'USStatesShipping'.
 */
export const USStates = [
  { title: 'AA', shipping: true, military: true } /* armed forces americas but not canada */,
  { title: 'AE', shipping: true, military: true } /* armed forced europe / mid-east / africa / canada */,
  { title: 'AK', shipping: true },
  { title: 'AL', shipping: true },
  { title: 'AP', shipping: true, military: true } /* armed forces pacific */,
  { title: 'AR', shipping: true },
  { title: 'AS' } /* america samoa */,
  { title: 'AZ', shipping: true },
  { title: 'CA', shipping: true },
  { title: 'CO', shipping: true },
  { title: 'CT', shipping: true },
  { title: 'DC', shipping: true } /* washington DC */,
  { title: 'DE', shipping: true },
  { title: 'FL', shipping: true },
  { title: 'FM' } /* federates states micronesia */,
  { title: 'GA', shipping: true },
  { title: 'GU' } /* guam */,
  { title: 'HI', shipping: true },
  { title: 'IA', shipping: true },
  { title: 'ID', shipping: true },
  { title: 'IL', shipping: true },
  { title: 'IN', shipping: true },
  { title: 'KS', shipping: true },
  { title: 'KY', shipping: true },
  { title: 'LA', shipping: true },
  { title: 'MA', shipping: true },
  { title: 'MD', shipping: true },
  { title: 'ME', shipping: true },
  { title: 'MI', shipping: true },
  { title: 'MN', shipping: true },
  { title: 'MO', shipping: true },
  { title: 'MP' } /* northern mariana islands */,
  { title: 'MS', shipping: true },
  { title: 'MT', shipping: true },
  { title: 'NC', shipping: true },
  { title: 'ND', shipping: true },
  { title: 'NE', shipping: true },
  { title: 'NH', shipping: true },
  { title: 'NJ', shipping: true },
  { title: 'NM', shipping: true },
  { title: 'NV', shipping: true },
  { title: 'NY', shipping: true },
  { title: 'OH', shipping: true },
  { title: 'OK', shipping: true },
  { title: 'OR', shipping: true },
  { title: 'PA', shipping: true },
  { title: 'PR' } /* puerto rico */,
  { title: 'PW' } /* palau */,
  { title: 'RI', shipping: true },
  { title: 'SC', shipping: true },
  { title: 'SD', shipping: true },
  { title: 'TN', shipping: true },
  { title: 'TX', shipping: true },
  { title: 'UT', shipping: true },
  { title: 'VA', shipping: true },
  { title: 'VI' } /* virgin islands */,
  { title: 'VT', shipping: true },
  { title: 'WA', shipping: true },
  { title: 'WI', shipping: true },
  { title: 'WV', shipping: true },
  { title: 'WY', shipping: true },
];

export const USStatesShipping = USStates.filter(state => state.shipping);

// list of common domains for suggestion in email field.
export const domainsList = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'rediffmail.com',
  'academy.com',
  'aol.com',
  'att.net',
  'icloud.com',
  'bellsouth.net',
  'comcast.net',
  'sbcglobal.net',
];
export const OUT_OF_STOCK = 'OUT_OF_STOCK';
// default error key
export const DEFAULT_KEY = '_ERR_DEFAULT_KEY';

// GC error keys
export const TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT = '_TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT';
export const TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT_CHECKOUT = '_TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT_CHECKOUT';
export const TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT_TEL = '_TOTAL_GC_AMOUNT_EXCEDED_MAX_LIMIT_TEL';

export const COUNTRY = 'US';
export const CURRENCY = 'USD';
export const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const PREVIOUS_URL = 'previousUrl';
export const SUB_URL = /(checkout|cart)/;
export const CART_REFER = 'cartRefer';
export const MAX_LENGTH = '50';
export const MAX_LENGTH_ZIPCODE = '5';
export const MAX_LENGTH_PHONE = '10';
export const COOKIE_STORE_ID = 'WC_StLocId';

// cookie to check if checkout is enabled
export const CHECKOUT_COOKIE = 'WC_OrdId';
export const DATE_MONTH_FORMAT = 'MMMDD';
export const DATE_MONTH_YEAR_FORMAT = 'MMMM DD, YYYY';
export const LONG_MONTH_DATE_FORMAT = 'MMMM DD';
export const SHORT_MONTH_DATE_FORMAT = 'MMM DD';
export const SHORT_MONTH_DATE_YEAR_FORMAT = 'MMM DD, YYYY';
export const YEAR_MONTH_DATE_FORMAT = 'YYYY-MM-DD';
export const MONTH_DATE_YEAR_FORMAT = 'MM/DD/YY';

export const TODAY = 'today';
export const TOMORROW = 'tomorrow';
export const ITEM_NOT_AVAILABLE = 'Sorry, we don’t have enough of this item to proceed.';
export const ERR_KEY_MISSING = '_ITEM_NOT_AVAILABLE';

export const DAY = 'DAY';

// Status Codes
export const HTTP_STATUS_CODE_201 = 201;
export const HTTP_STATUS_CODE_401 = 401;
export const HTTP_STATUS_CODE_403 = 403;

// FAM constants
export const FAM_PAGE_TYPE_ALL = 'FAM_ALL';
export const FAM_PAGE_TYPE_PDP = 'FAM_PDP';
export const UNAUTHORIZED_STATUS = [HTTP_STATUS_CODE_401, HTTP_STATUS_CODE_403];
export const ZIP_CODE_MAX_DISPLAY = 5;

export const STR_FREE = 'FREE';

export const WCS_PAGE_ID = 'reskin';

export const STORE_ZIP_CODE = 'WC_StZip_Selected';
export const PUT_SUCCESS_CODE = 204;

export const CART_USER_CHANGED_ZIP = 'cartUserChangedZip';
export const CURRENT_STATE_CODE_ON_CART = 'currentStateCodeOnCart';

export const GEO_LOCATED_ZIP_CODE = 'geoLocatedZipCode';
export const AK_LOCATED_ZIP_CODE = 'akLocatedZipCode';
export const AK_LOCATED_LAT_LNG = 'akLocatedLatLng';
export const DEFAULT_ADDRESS_ZIPCODE = 'defaultAddressZipcode';
export const RECOVER_SIGNIN_TOAST = 'recoverAccountSignInToast';

/**
 * Function to override withCredentials
 * Certain third party API, withCredentials should be false, to not allow pass cookie.
 * If you want to call API with withCredentials=false, please update regex below.
 */
export const blockWithCredentials = url => !url.match(/(ip-api|maps\.googleapis|google)\.com/);
export const UNKNOWN = 'unknown';
export const UNKNOWN_MSG = 'Some unknown error occurred!';
export const ERROR_SESSION_KEY = 'error_debug';
export const COOKIE_USERTYPE = 'USERTYPE';
export const COOKIE_USERACTIVITY = 'USERACTIVITY';
export const COOKIE_WC_USERACTIVITY = 'WC_USERACTIVITY';
export const TAX_SERVICE_URL = /(\/api\/taxes\/order\/\d{0,100}\/tax\b)/;
export const GUEST_IDENTITY = '/api/identity/guest';
export const HQ_ZIP_CODE = '77450';
export const HQ_LAT_LNG = { latitude: '29.8394', longitude: '-95.7377' };
export const Suffix = [{ title: 'Mr' }, { title: 'Ms' }, { title: 'Mrs' }];

export const CART_REDIRECT_URL = '/shop/cart';
export const CHECKOUT_REDIRECT_URL = '/checkout';

export const IS_STS_ENABLED_COOKIE = 'IS_STS_ENABLED';

export const TOKENEX_ID_TYPE = {
  orderId: 'orderID',
  userId: 'userID',
};

export const SKU_IDENTIFIERS = {
  6316468: 'X_Small_Festival_Fuchsia',
  8250047: 'X_Small_Baroque_Rose',
  4163611: 'X_Small_Medieval_Blue',
};

export const FIRST_NAME = 'firstName';
export const LOGON_ID = 'logonId';
export const IMAGE_LOADING_THRESHOLD = 0.03;

export const LEGACY_JSP_PAGE_URL = '/api/template?url=/legacy-jsp-page';
export const GLOBAL_CONFIG_PAGE_URL = '/api/template?url=/global-configuration';
export const SOURCE_CMS = 'CONTENT_STACK';

// Paypal V2
export const paypalV2ScriptQuery =
  '&components=buttons,funding-eligibility&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const venmoScriptQuery =
  '&components=buttons,funding-eligibility&enable-funding=venmo&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const venmoPayIn4ScriptQuery =
  '&components=messages,buttons,funding-eligibility&enable-funding=venmo&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const payIn4ScriptQuery =
  '&components=messages,buttons,funding-eligibility&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const venmoPayIn4PayLaterScriptQuery =
  '&components=messages,buttons,funding-eligibility&enable-funding=venmo,paylater&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const venmoPayLaterScriptQuery =
  '&components=buttons,funding-eligibility&enable-funding=venmo,paylater&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const payIn4PaylaterScriptQuery =
  '&components=messages,buttons,funding-eligibility&enable-funding=paylater&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';
export const payLaterScriptQuery =
  '&components=buttons,funding-eligibility&enable-funding=paylater&disable-funding=card&integration-date=2018-01-01&commit=true&intent=order&currency=USD';

export const ACC_USER = 'ACC_USER';

// KOUNT UDF checkoutmethod values in payload of place order API call
export const customUdfPdp = 'Express - PDP';
export const customUdfCart = 'Express - Cart';
export const customUdfCheckout = 'Checkout Page';
export const customUdfExpressCheckout = 'Express - Checkout';

// Promotional Email and Transactional SMS
export const EMAIL_OPTIN = 'email_optin';
export const SMS_OPTIN = 'sms_optin';

// Remember me - partial authentication
export const ERR_PARTIAL_AUTHENTICATION = 'ERR_PARTIAL_AUTHENTICATION_NOT_ALLOWED';
export const LIST_API_URL = '/api/profile/r2/null/wishlist';
export const SERVICE_UNAVAILABLE_KEY = '_ERR_SERVICE_UNAVAILABLE_KEY';

// Klarna Tender Api's Query Param Name
export const KLARNA_TENDER = 'klarnaTender';

export const GEO_LOCATED_REGION_CODE = 'geoLocatedRegionCode';

export const BADGE_COLOR_MAP = {
  CLEARANCE: 'badge-yellow',
  HOT_DEAL: 'badge-red',
};

export const ADD_CHANNEL_HEADER_FOR_REQUESTS = [
  new RegExp(`^.*${'/api/search/v2/sitesearch'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/category'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/product'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/productinfo/v2'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/search/v2/sitesearch/fallback'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/profile/favorites/details'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/profile/favorites'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/profilelists/favorites/details'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/profilelists/favorites'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/profilelists/guest/favorite/details'.replace('/', '\\/')}(?:\\/|$)`),
];
export const ADD_CHANNEL_HEADER_FOR_PREVIEW_REQUESTS = [
  new RegExp(`^.*${'/api/preview/search/v2/sitesearch'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/preview/category'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/preview/product'.replace('/', '\\/')}(?:\\/|$)`),
  new RegExp(`^.*${'/api/preview/search/v2/sitesearch/fallback'.replace('/', '\\/')}(?:\\/|$)`),
];

/* Look for a better home ... */
export const priceMessageMap = {
  hotDealsAvailable: 'HOT_DEAL',
  clearanceStylesAvailable: 'CLEARANCE',
  someStylesAvailableOnline: 'ONLINE_ONLY',
};

export const USER_PROFILE_DATA = 'userProfileData';
